import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styles from './styles.scss';
import WBtn from '../../components/WBtn/WBtn';
import WSlider from '../../components/WSlider/WSlider';
import qs from "query-string";
import WJSON from '../../helpers/json';

class FacilityView extends Component 
{
   constructor(props){
    super(props);

    let item = {}

    let query = qs.parse(props.location.search);

    if (query.item)
    {
      item = WJSON.decode(query.item)
    }

    this.state = { item : item };

  }

  render()
  {

    const { pics  } = this.state.item
    const item = this.state.item
    let slider_image = pics
    
    return (
      <div className={styles.page_container}>
        <WSlider imgs={slider_image}/>
        <div className={[styles.padding_container, styles.view].join(' ')}>
          <div className={styles.title_area}>
            <div className={styles.page_title}>{this.state.item.name}</div>
            <div className={styles.points}>
              <div className={styles.point}>預約扣點：{this.state.item.point}點</div>
              <div className={styles.point}>{item.cleaning_point_type === 'C' ? '清潔費' : '清潔扣點'}：{this.state.item.cleaning_point}</div>
            </div>
          </div>
          <div className={styles.content_area}>
            <div className={styles.text}>{this.state.item.desc}</div>
          </div>
          <div className={[styles.content_area, styles.btn_area].join(' ')}>
            <Link to={{
                pathname: '/booking?item='+JSON.stringify(this.state.item),
                state: this.state.item
              }} >
              <WBtn title="我要預約"/>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default FacilityView;


// WEBPACK FOOTER //
// ./src/views/Facility/FacilityView.js